import { useState } from "react";
import { faqs } from "@/mocks/home";
import SectionHeading from "@/components/feature/SectionHeading";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-10 lg:gap-14">
        <SectionHeading
          eyebrow="Q & A"
          title="关于回忆与书写，常见的问题"
          description="如果你是第一次写下自己的往事，这些回答也许能让你更轻松地开始。"
        />

        <div className="flex flex-col divide-y divide-background-200 border-t border-b border-background-200">
          {faqs.map((item, index) => {
            const open = openIndex === index;
            return (
              <div key={item.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer group"
                >
                  <span className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-700 transition-colors">
                    {item.q}
                  </span>
                  <span
                    className={`shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors ${
                      open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={`text-lg ${open ? "ri-subtract-line" : "ri-add-line"}`}></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    open ? "max-h-60 pb-5" : "max-h-0"
                  }`}
                >
                  <p className="text-sm leading-relaxed text-foreground-600 pr-10">{item.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}